namespace Solovis.Reports.Parameters.AllMarketValuesForDate {

    export interface AllMarketValuesForDateOtherOptions {
        includeLiquidityModels?: boolean;
    }
    
    export class AllMarketValuesForDateOtherOptionsParameterControl extends Solovis.UI.BaseControl {

        private _otherOptions: AllMarketValuesForDateOtherOptions;

        private _otherLabel;
        private _otherEditLink;

        constructor(options) {
            super(options);

            this._otherOptions = (typeof options.initialValue !== "undefined") ? options.initialValue : null;
        }


        public doRender() {
            let self = this;

            this._otherLabel = $("<a>").text("Other Options").appendTo(this.container);
            this._otherLabel.click(function () {
                self._showAllMarketValuesForDateOtherOptionsEditor();
            });

            this._otherEditLink = $("<a>").appendTo(this.container)
                .css("padding-left", "5px")
                .html("<span class='fa fa-pencil'></span>");
            this._otherEditLink.click(function () {
                self._showAllMarketValuesForDateOtherOptionsEditor();
            });
        }


        private _showAllMarketValuesForDateOtherOptionsEditor() {
            let editorDialog = new AllMarketValuesForDateOtherOptionsEditorDialog({
                otherOptions: this._otherOptions,
                saveCallback: (newOtherOptions) => {
                    this.setParameterValue(newOtherOptions);
                }
            });

            editorDialog.show();            
        }


        public _setCurrentOtherOptions(newOtherOptions) {
            this._otherOptions = newOtherOptions;
        }

        public setParameterValue(newValue, more?) {
            Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
                this, AllMarketValuesForDateOtherOptionsParameterControl, this._setCurrentOtherOptions, newValue, more);
        }

        public getParameterValue() {
            return Solovis.deepCopy(this._otherOptions);
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }
    }

    export class AllMarketValuesForDateOtherOptionsEditorDialog {

        private _otherOptions: AllMarketValuesForDateOtherOptions;
        private _saveCallback;

        private _formBuilder: Solovis.UI.InputControls.FormBuilder;

        public constructor(options) {
            this._otherOptions = options.otherOptions ? options.otherOptions : {};
            this._saveCallback = options.saveCallback;
        }

        public show() {
            let otherOptions = this._otherOptions;

            let formBuilderDiv = $("<div>");
            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formBuilderDiv,
                width: 800,
                labelColumnWidth: 245
            });
            this._formBuilder = formBuilder;

            formBuilder.addEntry({
                name: "includeLiquidityModels",
                label: "Include Liquidity Models",

                help: "If enabled, the associated Liquidity Model will be shown for each asset.",

                initialValue: otherOptions.includeLiquidityModels ? true : false,

                editor: {
                    type: "bool"
                }
            });

            formBuilder.setupDone();

            formBuilder.showAsDialog({
                title: "Edit Other Options",

                desiredWidth: 800,
                desiredHeight: 1000,

                showSaveCancel: true,
                saveButtonText: "OK",

                saveCallback: () => {
                    let newOptions = this._getNewOtherOptions();

                    this._saveCallback(newOptions);

                    return true;
                }
            });
        }

        private _getNewOtherOptions() {
            let newOtherOptions: AllMarketValuesForDateOtherOptions = {};

            let includeLiquidityModels = this._formBuilder.getValueByName("includeLiquidityModels");
            if (includeLiquidityModels) {
                newOtherOptions.includeLiquidityModels = true;
            }

            return newOtherOptions;
        }
    }

}